/** Legacy PIXI `tableLevel` / felt color — same indices as `PokerTable` `roomImage`. */
const ROOM_SLUG_TO_LEVEL: Record<string, number> = {
	sofia: 1,
	london: 2,
	paris: 3,
	monaco: 4,
	vip: 5,
	macao: 5,
	vegas: 6,
};

/**
 * Resolves `tableLevel` for game init. Prefer `roomSlug` mapping (the canonical source);
 * fallback to numeric `legacyRoomId` from API when slug is unavailable
 * (e.g. from MyTablesModal which does not pass a slug).
 */
export function resolveSvaraTableLevel(legacyRoomId?: number, roomSlug?: string): number {
	const key = roomSlug?.trim().toLowerCase();
	if (key && ROOM_SLUG_TO_LEVEL[key] !== undefined) {
		return ROOM_SLUG_TO_LEVEL[key];
	}
	if (typeof legacyRoomId === 'number' && !Number.isNaN(legacyRoomId)) {
		return legacyRoomId;
	}
	return 1;
}
